module.exports = __webpack_public_path__ + "img/Loginbonus.7b76fde1.png";